import 'weightmans-ui-vue/styles'
import './styles/styles.scss'

import { createApp } from 'vue'
import { installModules } from './utils'

import App from './App.vue'
import modules from './modules'

const app = createApp(App)

installModules(app, modules)
